/* Legal & Company Information — Google Maps JS API mode for the hero map.
   Draws the accent pin and anchors the "We are here" card to the office
   coordinates so it pans together with the map. */
(function () {
  const SELECTOR = {
    canvas: '.legal-hero__map-canvas',
    media: '.legal-hero__map-media',
    tooltip: '.legal-hero__tooltip',
  };

  /* Where the pin sits inside the map, as a share of the map box (from Figma:
     desktop frame 53639-155407, mobile frame 52325-247912). */
  const FRAMING = {
    desktop: { pinX: 0.556, pinY: 0.842, pinW: 25, pinH: 36 },
    mobile: { pinX: 0.386, pinY: 0.436, pinW: 22, pinH: 36 },
  };

  let scriptPromise = null;

  function loadMapsScript(apiKey) {
    if (window.google && window.google.maps && window.google.maps.Map) {
      return Promise.resolve();
    }
    if (scriptPromise) return scriptPromise;
    scriptPromise = new Promise(function (resolve, reject) {
      window.__legalHeroMapReady = resolve;
      const script = document.createElement('script');
      script.src =
        'https://maps.googleapis.com/maps/api/js?key=' +
        encodeURIComponent(apiKey) +
        '&loading=async&language=en&region=GB&callback=__legalHeroMapReady';
      script.async = true;
      script.onerror = reject;
      document.head.appendChild(script);
    });
    return scriptPromise;
  }

  function pinIcon(color, width, height) {
    const svg =
      '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="36" viewBox="0 0 28 36">' +
      '<path d="M14 0C6.268 0 0 6.268 0 14c0 10.5 14 22 14 22s14-11.5 14-22C28 6.268 21.732 0 14 0Z" fill="' + color + '"/>' +
      '<circle cx="14" cy="13.5" r="5.5" fill="#fff"/>' +
      '</svg>';
    return {
      url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg),
      scaledSize: new google.maps.Size(width, height),
      anchor: new google.maps.Point(width / 2, height),
    };
  }

  function attachTooltipOverlay(map, position, tooltip) {
    const overlay = new google.maps.OverlayView();

    overlay.onAdd = function () {
      tooltip.classList.add('legal-hero__tooltip--anchored');
      this.getPanes().floatPane.appendChild(tooltip);
    };

    overlay.draw = function () {
      const projection = this.getProjection();
      if (!projection) return;
      const point = projection.fromLatLngToDivPixel(position);
      if (!point) return;
      // 36px pin height + 7px gap between the pin and the card, as in the design
      const top = point.y - 36 - 7 - tooltip.offsetHeight;
      tooltip.style.left = Math.round(point.x - 16) + 'px';
      tooltip.style.top = Math.round(top) + 'px';
    };

    overlay.onRemove = function () {
      if (tooltip.parentNode) tooltip.parentNode.removeChild(tooltip);
    };

    overlay.setMap(map);
  }

  function initCanvas(canvas) {
    if (canvas.dataset.mapInit === 'true') return;
    canvas.dataset.mapInit = 'true';

    const lat = parseFloat(canvas.dataset.lat);
    const lng = parseFloat(canvas.dataset.lng);
    const apiKey = canvas.dataset.apiKey;
    if (!apiKey || Number.isNaN(lat) || Number.isNaN(lng)) return;

    loadMapsScript(apiKey)
      .then(function () {
        const desktop = window.matchMedia('(min-width: 769px)').matches;
        const frame = desktop ? FRAMING.desktop : FRAMING.mobile;
        const zoom = desktop
          ? parseFloat(canvas.dataset.zoom) || 17
          : parseFloat(canvas.dataset.zoomMobile) || 16;

        const position = new google.maps.LatLng(lat, lng);
        const map = new google.maps.Map(canvas, {
          center: position,
          zoom: zoom,
          mapTypeControl: false,
          streetViewControl: false,
          fullscreenControl: false,
          zoomControl: false,
          cameraControl: false,
          gestureHandling: 'cooperative',
        });

        if (canvas.dataset.showPin === 'true') {
          /* eslint-disable-next-line no-new */
          new google.maps.Marker({
            position: position,
            map: map,
            icon: pinIcon(canvas.dataset.pinColor || '#26AD4F', frame.pinW, frame.pinH),
            title: canvas.dataset.pinTitle || '',
          });
        }

        // Shift the viewport so the pin lands where the design puts it instead of
        // dead center. panBy needs the projection, hence the idle listener.
        google.maps.event.addListenerOnce(map, 'idle', function () {
          map.panBy(
            (0.5 - frame.pinX) * canvas.offsetWidth,
            (0.5 - frame.pinY) * canvas.offsetHeight
          );
        });

        // On mobile the card is a static overlay pinned to the bottom of the map
        // (as designed); only on desktop does it follow the coordinates.
        const media = canvas.closest(SELECTOR.media);
        const tooltip = media && media.querySelector(SELECTOR.tooltip);
        if (tooltip && desktop) attachTooltipOverlay(map, position, tooltip);
      })
      .catch(function (error) {
        console.error('Legal hero map failed to load', error);
      });
  }

  function initAll(root) {
    (root || document).querySelectorAll(SELECTOR.canvas).forEach(initCanvas);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
